import React from 'react';

import { Button, makeStyles } from '@material-ui/core';

interface IClasses {
    [key: string]: string;
}

interface IProps {
    classes?: IClasses;
    children: React.ReactNode;
    variant?: 'text' | 'outlined' | 'contained';
    onClick: () => void;
    autoFocus?: boolean;
    dangerous?: boolean;
}

function DialogButton({ classes, children, dangerous, ...otherProps }: IProps) {
    const dialogButtonClasses = useStyles();
    return (
        <Button
            classes={{
                contained: dangerous
                    ? dialogButtonClasses.dangerStyle
                    : dialogButtonClasses.contained,
                outlined: dialogButtonClasses.outlined,
                ...(classes ?? {})
            }}
            fullWidth
            size="large"
            {...otherProps}>
            {children}
        </Button>
    );
}

const useStyles = makeStyles((theme: any) => ({
    contained: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.background.dark,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light
        }
    },
    outlined: {
        color: theme.palette.grey.variant3,
        border: `1px solid ${theme.palette.grey.variant3}`
    },
    dangerStyle: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.background.dark
    }
}));

export default DialogButton;
